import styled from 'styled-components';

export const NavGlobal = styled.div`
  display: flex;

  @media (max-width: 1099px) {
    display: none;
  }
`;

export const Meta = styled.div`
  display: flex;

  &.meta_mbl_menu {
    display: none;
    @media (max-width: 1099px) {
      display: block;
      padding-left: 20px;
      padding-right: 20px;
      padding-top: 12px;
      width: fit-content;
    }
  }

  &[dir='ltr'] {
    letter-spacing: 1.82px;

    @media (max-width: 1099px) {
      font-size: 12px;
    }
  }

  a {
    font-weight: 500;
    @media (max-width: 1099px) {
      padding: 8px 5px;
      opacity: 1;
      position: relative;
    }
  }
`;
